<script>
  import axios from 'axios'

  export default {
    data () {
      return {
        state: ''
      }
    },

    props: ['address'],

    methods: {
      async download() {
        // produce a list of URLs to download with web and pq versions
        let files = this.address.photos.reduce((obj, photo) => {
          return Object.assign(obj, {
            [`WQ_${photo.path}`]: process.env.MIX_CDN + '2000x2000/' + photo.path,
            [`PQ_${photo.path}`]: process.env.MIX_CDN + photo.path
          })
        }, {})

        try {
          this.state = 'processing'
          let response = await axios.post(process.env.MIX_ZIP_URL, { zip: `${this.address.name}.zip`, files})
          window.location = process.env.MIX_CDN + response.data.Key

          this.state = 'done'
        }
        catch (err) {
          console.error(err)
          this.state = 'error'
        }
      }
    }
  }
  </script>
<template>
  <a @click="download" class="button is-primary" :class="{ 'is-loading': state === 'processing' }">
    <span class="icon is-small">
      <i class="fa" :class="{ 'fa-check': state === 'done', 'fa-download': state === '', 'fa-times': state === 'error' }"></i>
    </span>
    <span>Download All</span>
  </a>
</template>
